import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import {AuthHydrate} from '@/features/auth'
import {CreateRoomPage} from '@/pages/create-room'
import {ForgotPasswordPage} from '@/pages/forgot-password'
import {LoginPage} from '@/pages/login'
import {RegisterPage} from '@/pages/register'
import {ResetPasswordPage} from '@/pages/reset-password'
import {VerifyEmailPage} from '@/pages/verify-email'
import {VerifiedPage} from '@/pages/verified'
import {RoomPage} from '@/pages/room'
import {RecordingsPage} from '@/pages/recordings'
import {NotFoundPage} from '@/pages/not-found'
import '@livekit/components-styles'
import '../styles/index.css'

function App() {
  return (
    <Router>
      <AuthHydrate />
      <Routes>
        <Route path="/" element={<CreateRoomPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/verified" element={<VerifiedPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/room/:roomId" element={<RoomPage />} />
        <Route path="/recordings" element={<RecordingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  )
}

export default App
